var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWeight = function SvgWeight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "transparent",
    d: "M0 0h48v48H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20.976 14.755c0-.434.12-.75.405-1.056.284-.307.577-.437.979-.437h3.28c.764 0 1.385.67 1.385 1.493v2.728l-1.408-.147a.878.878 0 0 0-.095-.005H22.48a.878.878 0 0 0-.095.005l-1.408.147v-2.728zm17.98 22.863-5.431-18.802c-.118-.409-.453-.702-.848-.743l-1.702-.178v-3.14C30.975 11.582 28.582 9 25.64 9h-3.28c-1.446 0-2.751.583-3.773 1.685-1.022 1.103-1.562 2.51-1.562 4.07v3.14l-1.702.178c-.395.041-.73.334-.847.744l-5.431 18.8a1.13 1.13 0 0 0 .147.949.966.966 0 0 0 .796.434h28.025c.314 0 .61-.161.795-.434.186-.273.241-.625.147-.948z"
  }))));
};
export default SvgWeight;